import { render } from "./ArenaView.vue?vue&type=template&id=01f5f23a&scoped=true"
import script from "./ArenaView.vue?vue&type=script&lang=js"
export * from "./ArenaView.vue?vue&type=script&lang=js"

import "./ArenaView.vue?vue&type=style&index=0&id=01f5f23a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f5f23a"]])

export default __exports__